import styles from "./Toast.module.css";
import Icon from "./Icon";
import { Dispatch, SetStateAction, useEffect } from "react";
import { Color } from "./Common";

// 등록 완료, 수정 완료, 삭제 완료, 신고 완료
export const enum ToastType {
    ADD,
    EDIT,
    DELETE,
    REPORT,
    DEFAULT,
    WARNING,
}

export interface ToastData {
    type: ToastType;
    target?: string;
    message?: string;
    iconType?: string;
}

interface ToastStyles {
    icon: string; // icon 이름(=Icons.tsx 내 변수명과 일치해야 함)
    iconColor: string; // 스타일 색상(=Common.tsx 내 iconColor 프리셋 색상명과 일치해야 함)
    color: string;
    message: string; // 토스트 메시지
}

interface ToastProps {
    data: ToastData;
    setToast: Dispatch<SetStateAction<ToastData | undefined>>;
    message?: string; // 토스트 메시지
    iconType?: string;
}

/**
 * 공통 토스트 컴포넌트
 * @author smyun
 * @since 2024-09-24 14:43:17
 * @param props ToastProps
 * @props type: 토스트 메시지 종류
 *        setToast: toast 상태
 *        target?
 * @returns Toast
 */

const Toast = (props: ToastProps) => {
    const { iconType, type, target, message } = props.data;

    const toastStyles: ToastStyles = {
        color: Color.MAIN,
        iconColor: "default",
        icon: "",
        message: "",
    };

    // 이야기 등록, 신고 완료, 수정 완료, 삭제 완료, 신규장소 등록 완료, 신규장소 일괄등록 완료,
    switch (type) {
        case ToastType.ADD:
            toastStyles.icon = "addTask";
            toastStyles.iconColor = "default";
            toastStyles.color = Color.MAIN;
            toastStyles.message = target ? target + " 등록이 완료되었습니다." : "등록이 완료되었습니다.";
            break;

        case ToastType.EDIT:
            toastStyles.icon = "alterTask";
            toastStyles.iconColor = "default";
            toastStyles.color = Color.MAIN;
            toastStyles.message = "수정이 완료되었습니다.";
            break;

        case ToastType.DELETE:
            toastStyles.icon = "del";
            toastStyles.iconColor = "red";
            toastStyles.color = Color.ACCENT;
            toastStyles.message = "삭제가 완료되었습니다.";
            break;

        case ToastType.REPORT:
            toastStyles.icon = "warn";
            toastStyles.iconColor = "default";
            toastStyles.color = Color.MAIN;
            toastStyles.message = "신고가 완료되었습니다.";
            break;

        case ToastType.WARNING:
            toastStyles.icon = "warn";
            toastStyles.iconColor = "red";
            toastStyles.color = Color.ACCENT;
            toastStyles.message = message ? message : '경고 메시지입니다.';
            break;

        case ToastType.DEFAULT:
            toastStyles.icon = iconType!;
            toastStyles.iconColor = "default";
            toastStyles.color = Color.MAIN;
            toastStyles.message = message ? message : '';
            break;
    }

    const style = {
        color: toastStyles.color,
        border: `1px solid ${toastStyles.color}`,
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            props.setToast(undefined);
        }, 3000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <div className={styles.toast} style={style}>
            <Icon name={toastStyles.icon} color={toastStyles.iconColor} />
            <span>{toastStyles.message}</span>
        </div>
    );
};

export default Toast;
